import React from "react";
import { ThemedButtonView } from "./view";
import { styles } from "./styles";

export const ThemedButton = React.forwardRef((props, ref) => (
  <ThemedButtonView {...props} styles={styles} ref={ref} />
));
